import moment from 'moment';
import fetch from '@/utils/fetch';
import { message } from 'antd';

const model = {
  state: {
    queryParams: {
      per_page: 10,
      cur_page: 1,
      award_status: '',
      range: [moment().add(-14, 'days'), moment()],
      audit_time_start: moment().add(-14, 'days').startOf('day'),
      audit_time_end: moment().endOf('day'),
    },
    list: [],
    total: 0,
    loading: false,
    logList: [],
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { Allowance }, getState }) => ({
    async getList() {
      const { union_shop_id } = getState().basic;
      const { queryParams } = getState().Allowance;
      if (queryParams.audit_time_end.diff(queryParams.audit_time_start, 'days') > 14) {
        message.error('查询日期范围不能超过15天');
        return;
      }
      Allowance.setState({ loading: true });
      const data = await fetch('/company/Allowance/recommendlist', {
        params: {
          union_shop_id,
          ...queryParams,
          range: '',
          audit_time_start: queryParams.audit_time_start.valueOf().toString().slice(0, 10),
          audit_time_end: queryParams.audit_time_end.valueOf().toString().slice(0, 10),
        },
      });
      if (data) {
        Allowance.setState({
          list: data.list,
          total: data.total,
          loading: false,
        });
      }
    },

    onSearch(queryParams) {
      Allowance.setState({
        queryParams: {
          ...queryParams,
          range: [moment(queryParams.audit_time_start), moment(queryParams.audit_time_end)],
        },
      });
      Allowance.getList();
    },

    onNav(page) {
      const { queryParams } = getState().Allowance;
      Allowance.setState({
        queryParams: { ...queryParams, cur_page: page },
      });
      Allowance.getList();
    },

    onReset() {
      Allowance.setState({
        queryParams: {
          per_page: 10,
          cur_page: 1,
          award_status: '',
          range: [moment().add(-14, 'days'), moment()],
          audit_time_start: moment().add(-14, 'days').startOf('day'),
          audit_time_end: moment().endOf('day'),
        },
      });
    },
    async onExport() {
      const { union_shop_id } = getState().basic;
      const { queryParams } = getState().Allowance;
      const result = await fetch('/company/Allowance/importrecommendlist', {
        params: {
          union_shop_id,
          ...queryParams,
          range: '',
          audit_time_start: queryParams.audit_time_start.valueOf().toString().slice(0, 10),
          audit_time_end: queryParams.audit_time_end.valueOf().toString().slice(0, 10),
        },
      });
      if (result && result.file_url) {
        message.success('导出成功');
        window.location.href = result.file_url;
      }
    },
    async grantAward(params) {
      const { union_shop_id } = getState().basic;
      const result = await fetch('/company/Allowance/grantaward', {
        type: 'POST',
        params: { ...params, union_shop_id },
      });
      if (result) {
        message.success('操作成功，奖励发放中');
        Allowance.getList();
        return true;
      }
      return false;
    },
    async getLogList() {
      const { union_shop_id } = getState().basic;
      const data = await fetch('/company/account/allowancechangelist', {
        params: { union_shop_id },
      });
      if (data) {
        Allowance.setState({ logList: data.list });
      }
    },
    async downloadLog(log_id) {
      const { union_shop_id } = getState().basic;
      const data = await fetch('/company/account/getallowancechangefile', {
        params: { union_shop_id, log_id },
      });
      if (data && data.file_url) {
        window.location.href = data.file_url;
      }
    },
  }),
};

export default model;
